import * as React from 'react';
import { FieldRenderProps } from 'react-final-form';
import { TextArea as TextAreaCore } from '@mc/react-core';
import { Field } from '../Field';
import { FormItem } from './FormItem';
import { MFieldProps } from '../types';
import '../TextArea.scss';

export type TextAreaProps = MFieldProps<
  React.ComponentProps<typeof TextAreaCore>
>;
export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  (
    {
      name,
      validate,
      className,
      inputClassName,
      onChange: customOnChange,
      disabled,
      required,
      ...other
    },
    ref
  ) => {
    return (
      <FormItem
        name={name}
        className={className}
        required={required}
        disabled={disabled}
      >
        <Field name={name} validate={validate}>
          {({
            input: { value, onChange, name, ...nother },
          }: FieldRenderProps<string>) => {
            const handleChange = React.useCallback(
              (e: React.ChangeEvent<HTMLTextAreaElement>) => {
                let realVal: string | undefined = e.target.value;
                if (realVal === '') {
                  realVal = undefined;
                }
                onChange({ target: { name, value: realVal } });
                customOnChange && customOnChange(realVal as any);
              },
              [customOnChange, onChange, name]
            );
            return (
              <TextAreaCore
                className={'final-form-textarea ' + inputClassName}
                // @ts-ignore
                ref={ref}
                {...nother}
                name={name}
                {...other}
                disabled={disabled}
                onChange={handleChange}
                value={value}
              />
            );
          }}
        </Field>
      </FormItem>
    );
  }
);
